var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"main-loading text-gray-400 text-center"},[_c('font-awesome-icon',{attrs:{"icon":"exclamation","size":"4x","fixed-width":""}}),_c('p',{staticClass:"pt-3 pb-0"},[_vm._v("Page not found")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }